import {CanActivateFn, Router} from '@angular/router'
import {inject} from '@angular/core'

export const canAccessDeleteCryptoUserPageGuard: CanActivateFn = () => {
  const router = inject(Router)

  const state = router.getCurrentNavigation()?.extras.state as { user?: string }

  if (!state?.user) {
    router.navigate(['/dashboard']).then()
    return false
  }

  return true
}
